import { graphql } from "../gql";

export const getAnnotationLabelsQueryDoc = graphql(`
  query getAnnotationLabels {
    annotationLabels {
      ...AnnotationLabelFragment
    }
  }
`);
